<template>
  <div>
    <base-material-card
      color="indigo"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
      top-actions
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t('Components.Lists.CustomerList.Title') }}
        </div>
      </template>

      <template v-slot:top-actions>
        <v-btn
          v-if="!hideNew"
          class="px-2 ml-1"
          color="success"
          @click="$emit('new')"
        >
          {{ $t('General.Buttons.New', ['Customer']) }}
        </v-btn>
        <v-btn
          class="px-2 ml-1"
          color="info"
          @click="$emit('refresh')"
        >
          {{ $t('General.Buttons.Refresh') }}
        </v-btn>
      </template>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('General.Labels.Search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="computedHeaders"
        :items="customers"
        :search.sync="search"
        :sort-desc="[false]"
        :hide-default-header="true"
        multi-sort
        class="row-action"
      >
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th
                v-for="(header, i) in headers"
                :key="`header-${i}`"
              >
                {{ $t(header.text) }}
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr @click="$emit('itemClicked', item.uid)">
            <td v-if="!hideEdit || !hideOverview">
              <v-btn
                v-if="!hideOverview"
                class="px-2 ml-1"
                color="info"
                rounded
                small
                @click.stop="$emit('overview', item.uid)"
              >
                {{ $t('General.Buttons.Overview') }}
              </v-btn>
              <v-btn
                v-if="!hideEdit"
                class="px-2 ml-1"
                color="warning"
                rounded
                small
                @click.stop="$emit('edit', item.uid)"
              >
                {{ $t('General.Buttons.Edit') }}
              </v-btn>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.city }}</td>
            <td>{{ item.contactName }}</td>
            <td
              v-if="!hideEdit || !hideOverview"
              class="text-right"
            >
              <v-btn
                v-if="!hideEdit"
                class="px-2 ml-1"
                color="error"
                rounded
                small
                @click.stop="triggerDeleteCustomerDialog(item)"
              >
                {{ $t('General.Buttons.Delete') }}
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>

    <delete-customer-dialog
      :customer-to-delete="customerToDelete"
      @close="handleDeleteCustomerDialogClose"
      @deleteCustomer="handleDeleteCustomer"
    />
  </div>
</template>

<script>
  import DeleteCustomerDialog from '../dialogs/DeleteCustomerDialog.vue'

  export default {
    name: 'CustomerList',
    components: {
      DeleteCustomerDialog,
    },
    props: {
      customers: {
        type: Array,
        required: true,
        default: null,
      },
      hideOverview: {
        type: Boolean,
        required: false,
        default: false,
      },
      hideEdit: {
        type: Boolean,
        required: false,
        default: false,
      },
      hideNew: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: () => ({
      customerToDelete: null,
      showDeleteCustomerDialog: false,
      headers: [
        {
          sortable: false,
          text: '',
          width: '150',
        },
        {
          sortable: true,
          text: 'Components.Lists.CustomerList.TableHeaders.CompanyName',
          value: 'name',
        },
        {
          sortable: true,
          text: 'Components.Lists.CustomerList.TableHeaders.City',
          value: 'city',
        },
        {
          sortable: true,
          text: 'Components.Lists.CustomerList.TableHeaders.ContactName',
          value: 'contactName',
        },
        {
          sortable: false,
          text: '',
          width: '1%',
        },
      ],
      search: undefined,
    }),
    computed: {
      computedHeaders () {
        return this.headers.filter(h => !this.hideActionColumn || h.text !== '')
      },
      hideActionColumn () {
        return this.hideEdit && this.hideOverview
      },
    },
    created: function () {
    },
    methods: {
      triggerDeleteCustomerDialog (customer) {
        this.customerToDelete = customer
      },
      handleDeleteCustomer (customer) {
        this.$emit('deleteCustomer', customer.uid)
        this.handleDeleteCustomerDialogClose()
      },
      handleDeleteCustomerDialogClose () {
        this.customerToDelete = null
      },
    },
  }
</script>
